import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mississauga',
  templateUrl: './mississauga.component.html',
  styleUrls: ['./mississauga.component.css']
})
export class MississaugaComponent implements OnInit {

  constructor(private router: Router) {

    localStorage.setItem("currentPostalCode", 'L4X');
    localStorage.setItem("comingFromFranchise", 'Yes');
    //this.router.navigate(["home", "mississauga"]);
  }

  ngOnInit() {
  }

}
